var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.746 17.535c.228-.076.477-.058.69.05.934.472 1.966.716 3.014.714 2.556-.001 4.892-1.446 6.037-3.736.471-.933.716-1.965.713-3.011l.001-.403c-.189-3.426-2.924-6.161-6.3-6.35h-.453c-1.046-.002-2.078.243-3.015.716-2.286 1.143-3.73 3.479-3.732 6.037-.002 1.046.242 2.078.714 3.011.108.214.126.463.05.69l-1.14 3.423 3.421-1.141zm11.35-2.164c-1.448 2.896-4.407 4.726-7.643 4.728-1.201.003-2.388-.25-3.481-.742l-4.786 1.595c-.703.235-1.373-.435-1.138-1.138l1.595-4.786c-.491-1.093-.745-2.28-.742-3.48.002-3.237 1.832-6.196 4.724-7.641 1.187-.6 2.499-.91 3.826-.907l.5.001c4.341.24 7.808 3.707 8.049 8.098v.45c.003 1.328-.307 2.64-.905 3.822z",
    transform: "translate(-40 -330) translate(40 330)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/iconMessage.7c1a8d26.svg";
export { ForwardRef as ReactComponent };